import { Box, Typography } from '@mui/material'
import React from 'react'
import { useAppSelector } from '../../../store/reducers/store';
import { useTranslation } from 'react-i18next';

const FundFeesCalculatedProjection: React.FC = () => {
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const { t, i18n } = useTranslation();

    const total = portfolio.funds.reduce((a, b) => a + b.proportion * portfolio.fundraisingTarget, 0);
    const yearlyManagementRevenu = (portfolio.managementFees ? portfolio.managementFees : 0) * total;
    const carryFees = portfolio.carryFees ? portfolio.carryFees : 0;
    const carryRevenu = portfolio.multipleAtExit ? (total * (portfolio.multipleAtExit - 1) * carryFees) : 0;

    const textYearsCount = portfolio.portfolioLife?.replaceAll(/\+[0-9]+/gi, '');
    const yearsCount = parseInt(textYearsCount as string);
    const correctedYearsCount = isNaN(yearsCount) ? 0 : Math.min(yearsCount, 100);

    return <>
        <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
            {isNaN(yearsCount) ? 
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioProvidePortfolioLife')}</Typography>
                </Box>
            :
            [...Array(correctedYearsCount)].map((a,y) => (
                <Box display={"flex"} justifyContent={"space-between"} key={`year-${y}`}>
                    <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY') + (y+1)}</Typography>
                    <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
                </Box>
            ))}
            {/* <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY2')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY3')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY4')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY5')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY6')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY7')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{t('CreatePortfolioManagementFeesY8')}</Typography>
                <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>€{yearlyManagementRevenu.toLocaleString(i18n.language)}</Typography>
            </Box> */}
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"500"}>{t('CreatePortfolioTotalRevenueFromManagementFees')}</Typography>
            <Typography fontSize={"21px"} lineHeight={"25.6px"} fontWeight={"600"}>€{(yearlyManagementRevenu * correctedYearsCount).toLocaleString(i18n.language)}</Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"500"}>{t('CreatePortfolioTotalEstimatedRevenueFromCarry')}</Typography>
            <Typography fontSize={"21px"} lineHeight={"25.6px"} fontWeight={"600"}>€{carryRevenu.toLocaleString(i18n.language)}</Typography>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"500"}>{t('CreatePortfolioTotalEstimatedRevenue')}</Typography>
            <Typography fontSize={"21px"} lineHeight={"25.6px"} fontWeight={"600"}>€{(carryRevenu + yearlyManagementRevenu * correctedYearsCount).toLocaleString(i18n.language)}</Typography>
        </Box>
    </>
}

export default FundFeesCalculatedProjection